<template>
  <div class="content-text">
    <v-runtime-template :template="fixedContent" />
  </div>
</template>

<script>
import VRuntimeTemplate from "v-runtime-template"

export default {
    name: 'ContentRender',
    components: {
      VRuntimeTemplate
    },
    props: {
      content: {
        type: String,
        default: ''
      }
    },
    computed: {
      fixedContent() {
        return '<div class="content-text">' + this.content + '</div>'
      },
      contentString() {
        return this.content
      }
    }
}
</script>

<style lang="scss" scoped>
div.content-text {
    padding: 1rem;
    text-align: left;
}
</style>